import React, { useState, useEffect } from 'react';
import axios from 'axios';

const OfferTop = () => {
  const [offer, setOffer] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  });

  useEffect(() => {
    const fetchOffer = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/getoffertop`);
        if (response.data && response.data.length > 0) {
          setOffer(response.data[0]); // Get the first offer
        }
        setLoading(false);
      } catch (err) {
        setError(err.message);
        setLoading(false);
      }
    };

    fetchOffer();
  }, []);

  useEffect(() => {
    if (!offer || !offer.CountdownTimeDate) return;

    const calculateTimeLeft = () => {
      const endDate = new Date(offer.CountdownTimeDate);
      const now = new Date();
      const difference = endDate - now;

      if (difference > 0) {
        const days = Math.floor(difference / (1000 * 60 * 60 * 24));
        const hours = Math.floor((difference / (1000 * 60 * 60)) % 24);
        const minutes = Math.floor((difference / 1000 / 60) % 60);
        const seconds = Math.floor((difference / 1000) % 60);

        setTimeLeft({ days, hours, minutes, seconds });
      }
    };

    // Update immediately
    calculateTimeLeft();

    // Then update every second
    const timer = setInterval(calculateTimeLeft, 1000);

    return () => clearInterval(timer);
  }, [offer]);

  

  

  if (!offer) {
    return null; // Don't show anything if no offer exists
  }

  return (
    <div className="announcement-bar" >
      <div className="announcement-container">
        <div className="announcement-content">
          <div className="offer-tag">
            <span className="offer-icon"></span>
            <span className="offer-text">
              {offer.Title} {offer.SalePercent ? `${offer.SalePercent}` : ''}
            </span>
            <span className="offer-icon"></span>
          </div>
          
          {offer.CountdownTimeDate && (
            <div className="offer-timer">
              <span className="timer-text">Ends in: </span>
              <span className="timer-value">
                {timeLeft.days}d {timeLeft.hours}h {timeLeft.minutes}m {timeLeft.seconds}s
              </span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default OfferTop;